import { ElementRef } from '@angular/core';

export class HorizontalScroll<T extends HTMLElement> {
  private readonly _container: T;

  public get scrollWidth() {
    return this._container.scrollWidth;
  }

  public get clientWidth() {
    return this._container.clientWidth;
  }

  public get scrollOffset() {
    return this._container.scrollLeft;
  }

  public get maxScrollOffset() {
    return this.scrollWidth - this.clientWidth - 1;
  }

  constructor(element: ElementRef<T>, private readonly _offset: number = 20) {
    this._container = element.nativeElement;
  }

  public overflowed(): boolean {
    return this.scrollWidth > this.clientWidth;
  }

  public canScrollLeft(): boolean {
    return this.scrollOffset > 0;
  }

  public canScrollRight(): boolean {
    return this.scrollOffset < this.maxScrollOffset;
  }

  public scrollLeft(offset?: number): void {
    this._container.scrollLeft -= offset || this._offset;
  }

  public scrollRight(offset?: number): void {
    this._container.scrollLeft += offset || this._offset;
  }
}
